import React from 'react';
import { Card } from 'react-bootstrap';
import { Container } from 'react-bootstrap';
import { Row, Col } from 'react-bootstrap';
// import { Card, CardBody, CardText, CardTitle } from 'react-bootstrap';
import './Supports.css';

import supptouchbg from '../images/PageImg/SupportTouch-page-bg.jpg'
import HeaderSlide from '../components/HeaderSlide'
import { SuppTouchCon } from "../assets/SupportsData";
import { SuppTouchCar } from "../assets/SupportsData";
import { SuppTouchHmi } from "../assets/SupportsData";
import { SuppTouchInd } from "../assets/SupportsData";
import { SuppTouchLag } from "../assets/SupportsData";

import SuppTouchConImg from '../images/SupportImg/SuppTouchCon.jpg';
import SuppTouchCarImg from '../images/SupportImg/SuppTouchCar.jpg';
import SuppTouchHmiImg from '../images/SupportImg/SuppTouchHmi.jpg';
import SuppTouchIndImg from '../images/SupportImg/SuppTouchInd.jpg';
import SuppTouchLagImg from '../images/SupportImg/SuppTouchLag.jpg';

import { GoTopBtn } from '../components/GoTopBtn';

function SuportTouch() {
  // console.log("get into SuppTouch()");
  return (
    /* Support / Touch Category */
    <div className='support-page'>
      <div className='supportheader'
        style={{ backgroundImage: `url(${supptouchbg})`, height: "auto" }} >
        <HeaderSlide text={'Support / Touch'} />
        <h4 className='text-light'>&nbsp;images/PageImg/SupportTouch-page-bg.jpg</h4>
      </div>

      {/* Support / Touch Consumer */}
      <section id='supptouchcom' className='supptouch bg-info-subtle text-dark my-4'>
        <Container>
          <h2 className='title-holder fs-1 fw-bold text-primary'>Support / Touch Consumer</h2>
          <Row>
            <Col lg={6} className='d-flex flex-column justify-content-center'>
              <img src={SuppTouchConImg} className='mt-5 mt-lg-0' alt="" />
              <h5>images/SupportImg/SuppTouchCon.jpg</h5>
            </Col>
            <Col lg={6} className='d-flex flex-column justify-content-around'> {
              SuppTouchCon.map((touch) => (
                <Row key={touch.id}>
                  <Card className='bg-info-subtle border-1 p-0 m-0'>
                    <Card.Body className='d-flex justify-content-center'>
                      <Card.Title className='fs-2 text-primary px-3 my-1'> {touch.name} </Card.Title>
                      <Card.Text className='fs-4'>
                        <a href={`/ListingTouchsBySize/${touch.size}`} className='btn suppbtn-success'> {touch.text} </a>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Row>
              ))
            } </Col>
          </Row>
        </Container>
      </section>

      {/* Support / Touch Car */}
      <section id='supptouchcar' className='supptouch bg-primary-subtle text-dark my-4'>
        <Container>
          <h2 className='title-holder fs-1 fw-bold text-success'>Support / Touch Car</h2>
          <Row>
            <Col lg={6} className='d-flex flex-column justify-content-around'> {
              SuppTouchCar.map((touch) => (
                <Row key={touch.id}>
                  <Card className='bg-primary-subtle border-1 p-0 m-0'>
                    <Card.Body className='d-flex justify-content-center'>
                      <Card.Title className='fs-2 text-success px-3 my-1'> {touch.name} </Card.Title>
                      <Card.Text className='fs-4'>
                        <a href={`/ListingTouchsBySize/${touch.size}`} className='btn suppbtn-primary'> {touch.text} </a>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Row>
              ))
            } </Col>
            <Col lg={6} className='d-flex flex-column justify-content-center'>
              <img src={SuppTouchCarImg} className='mt-4 mt-lg-0' style={{ height: '60vh' }} alt="" />
              <h5>images/SupportImg/SuppTouchCar.jpg</h5>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Support / Touch HMI */}
      <section id='supptouchhmi' className='supptouch bg-info-subtle text-dark my-4'>
        <Container>
          <h2 className='title-holder fs-1 fw-bold text-primary'>Support / Touch HMI</h2>
          <Row>
            <Col lg={6} className='d-flex flex-column justify-content-center'>
              <img src={SuppTouchHmiImg} className='mt-5 mt-lg-0' style={{ height: '80vh' }} alt="" />
              <h5>images/SupportImg/SuppTouchHMI.jpg</h5>
            </Col>
            <Col lg={6} className='d-flex flex-column justify-content-around'> {
              SuppTouchHmi.map((touch) => (
                <Row key={touch.id}>
                  <Card className='bg-info-subtle border-1 p-0 m-0'>
                    <Card.Body className='d-flex justify-content-center'>
                      <Card.Title className='fs-2 text-primary px-3 my-1'> {touch.name} </Card.Title>
                      <Card.Text className='fs-4'>
                        <a href={`/ListingTouchsBySize/${touch.size}`} className='btn suppbtn-success'> {touch.text} </a>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Row>
              ))
            } </Col>
          </Row>
        </Container>
      </section>

      {/* Support / Touch Industary */}
      <section id='supptouchind' className='supptouch bg-primary-subtle text-dark my-4'>
        <Container>
          <h2 className='title-holder fs-1 fw-bold text-success'>Support / Touch Industary</h2>
          <Row>
            <Col lg={6} className='d-flex flex-column justify-content-around'> {
              SuppTouchInd.map((touch) => (
                <Row key={touch.id}>
                  <Card className='bg-primary-subtle border-1 p-0 m-0'>
                    <Card.Body className='d-flex justify-content-center'>
                      <Card.Title className='fs-2 text-success px-3 my-1'> {touch.name} </Card.Title>
                      <Card.Text className='fs-4'>
                        <a href={`/ListingTouchsBySize/${touch.size}`} className='btn suppbtn-primary'> {touch.text} </a>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Row>
              ))
            } </Col>
            <Col lg={6} className='d-flex flex-column justify-content-center'>
              <img src={SuppTouchIndImg} className='mt-4 mt-lg-0' style={{ height: '70vh' }} alt="" />
              <h5>images/SupportImg/SuppTouchInd.jpg</h5>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Support / Touch Large */}
      <section id='supptouchlag' className='supptouch bg-info-subtle text-dark my-4'>
        <Container>
          <h2 className='title-holder fs-1 fw-bold text-primary'>Support / Touch Large</h2>
          <Row>
            <Col lg={6} className='d-flex flex-column justify-content-center'>
              <img src={SuppTouchLagImg} className='mt-5 mt-lg-0' style={{ height: '80vh' }} alt="" />
              <h5>images/SupportImg/SuppTouchLag.jpg</h5>
            </Col>
            <Col lg={6} className='d-flex flex-column justify-content-around'> {
              SuppTouchLag.map((touch) => (
                <Row key={touch.id}>
                  <Card className='bg-info-subtle border-1 p-0 m-0'>
                    <Card.Body className='d-flex justify-content-center'>
                      <Card.Title className='fs-2 text-primary px-3 my-1'> {touch.name} </Card.Title>
                      <Card.Text className='fs-4'>
                        <a href={`/ListingTouchsBySize/${touch.size}`} className='btn suppbtn-success'> {touch.text} </a>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Row>
              ))
            } </Col>
          </Row>
        </Container>
      </section>
      <div> < GoTopBtn /> </div>
    </div>
  )
}

export default SuportTouch;

/*
<header className='mt-5'>
  <Container className='h-100 d-flex align-items-center justify-content-center'>
    <h1 className='text-light'>Support / Touch Panel</h1>
  </Container>
</header>
*/
/*
<Row>
  <Col lg={6} className='d-flex justify-content-center'>
    <img src={SuppTouchConImg} className='mt-5 mt-lg-0' alt="" />
    // <img src={SuppTouchConImg} className='mt-5 mt-lg-0' style={{ height: '80vh' }} alt="" />
    // <img src={SuppSensorSMImg} className='mt-5' style={{ height: '55vh' }} alt="" />
    // <img src={SuppSensorMLImg} className='mt-5' style={{ height: '80vh' }} alt="" />
    <h5>images/SupportImg/SuppTouchCon.jpg</h5>
  </Col>
  <Col lg={6} className='d-flex flex-column justify-content-around'> {
    SuppTouchCon.map((touch) => (
      <Row key={touch.id}>
        <Card className='bg-info-subtle border-1 p-0 m-0'>
          <Card.Body className='d-flex justify-content-center'>
            <Card.Title className='fs-2 text-primary px-3 my-1'> {touch.name} </Card.Title>
            // <Card.Title className='fs-2 text-success p-1 mx-2'> {sensor.name} </Card.Title>
            <Card.Text className='fs-4'>
              // <Card.Text className='text-center fs-4'>
              <a href={`/ListingTouchsBySize/${touch.size}`} className='btn suppbtn-success'> {touch.text} </a>
            </Card.Text>
          </Card.Body>
        </Card>
      </Row>
    ))
  } </Col>
</Row>
*/
